import { ILegalGroup } from "../models/response/legal-document/ILegalGroup";
import { apiClient } from "./apiClient";
import { apiGuestClient } from "./apiGuestClient";
export const LEGAL_DOCUMENT_ENDPOIT = "legal-document";
export const legalDocumentApi = {
    selectAll: () => apiGuestClient.get(`${LEGAL_DOCUMENT_ENDPOIT}`),
    insert: (request: ILegalGroup) => apiClient.post(`${LEGAL_DOCUMENT_ENDPOIT}`, request),
    update: (request: ILegalGroup) => apiClient.put(`${LEGAL_DOCUMENT_ENDPOIT}`, request),
    delete: (id: number) => apiGuestClient.delete(`${LEGAL_DOCUMENT_ENDPOIT}/${id}`),
}